import React, { useMemo } from "react";
import { useTheme } from "../context/ThemeContext";

interface ButtonProps {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  variant?: "primary" | "secondary";
  style?: React.CSSProperties;
}

const baseStyle: React.CSSProperties = {
  marginLeft: "0px",
  marginTop: "40px",
  width: "100%",
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "'Inter', sans-serif",
  fontWeight: 300,
  fontSize: "13px",
  border: "none",
  borderRadius: "2px",
  transition: "all 0.2s ease-in-out",
};

const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  disabled = false,
  variant = "primary",
  style = {},
}) => {
  const { theme, departmentColor } = useTheme();

  const primaryButtonColor =
    departmentColor || theme?.primary_button || theme?.primary || "#0a343d";

  const variants = useMemo<
    Record<"primary" | "secondary", React.CSSProperties>
  >(
    () => ({
      primary: {
        backgroundColor: primaryButtonColor,
        color: "#FFFFFF",
      },
      secondary: {
        backgroundColor: "#E5E7EB",
        color: "#111827",
      },
    }),
    [primaryButtonColor]
  );

  const finalStyle: React.CSSProperties = {
    ...baseStyle,
    ...variants[variant],
    opacity: disabled ? 0.6 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
    ...style,
  };

  return (
    <button
      style={finalStyle}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      onMouseEnter={(e) => {
        if (disabled) return;
        e.currentTarget.style.filter = "brightness(1.05)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.filter = "brightness(1)";
      }}
      onMouseDown={(e) => {
        if (disabled) return;
        e.currentTarget.style.transform = "scale(0.98)";
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      {text}
    </button>
  );
};

export default Button;
